import script from "./FadingQRCode.vue?vue&type=script&lang=ts&setup=true"
export * from "./FadingQRCode.vue?vue&type=script&lang=ts&setup=true"

import "./FadingQRCode.vue?vue&type=style&index=0&id=4bb48042&lang=scss&scoped=true"

import exportComponent from "/Users/einaroberg/projects/tjing-majblomman/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bb48042"]])

export default __exports__